import request from '@/utils/request'

export function signInHospital(data) {
    return request({
        url: 'HospitalInfo/AddHospitalInfo',
        method: 'post',
        data
    })
}

export function getHospital(data) {
    return request({
        url: 'HospitalInfo/GetHospitalInfobyName',
        method: 'post',
        data
    })
}

export function getHospital2(data) {
  return request({
    url: "HospitalInfo/GetHospitalInfobyName2",
    method: "post",
    data,
  });
}

export function updateHospitalInfo(data) {
  return request({
    url: "HospitalInfo/UpdateHospitalInfo",
    method: "post",
    data,
  });
}

export function getDuties(data) {
    return request({
        url: 'Duties/GetDutiesTable',
        method: 'post',
        data
    })
}

export function getProfessional(data) {
    return request({
        url: 'Major/GetMajorALL',
        method: 'post',
        data
    })
}

export function getProfessionalPost(data) {
    return request({
        url: 'Professionaltitle/GetProfessionaltitleALL',
        method: 'post',
        data
    })
}

export function getAllArea(data) {
  return request({
    url: "HospitalInfo/GetAllArea",
    method: "post",
    data,
  });
}

export function getHospitalArea(data) {
  return request({
    url: "HospitalInfo/GetHospitalArea",
    method: "post",
    data,
  });
}

export function updatePwd(data) {
  return request({
    url: "HospitalInfo/UpdatePwd",
    method: "post",
    data,
  });
}

export function updateProgress(data) {
  return request({
    url: "HospitalInfo/UpdateProgress",
    method: "post",
    data,
  });
}

export function deleteDataByMonth(data) {
  return request({
    url: "HospitalInfo/DeleteDataByMonth",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/hospital.js